import{__exports as e}from"../../../../_virtual/index24.js";export{__exports as default}from"../../../../_virtual/index24.js";Object.defineProperty(e,"__esModule",{value:!0}),e.getDefaultOptions=function(){return t},e.setDefaultOptions=function(e){t=e};var t={};
//# sourceMappingURL=index.js.map
